import { render, staticRenderFns } from "./a-product-period-card.vue?vue&type=template&id=1932ca4f&scoped=true&"
import script from "./a-product-period-card.vue?vue&type=script&lang=js&"
export * from "./a-product-period-card.vue?vue&type=script&lang=js&"
import style0 from "./a-product-period-card.vue?vue&type=style&index=0&id=1932ca4f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1932ca4f",
  null
  
)

export default component.exports